import { Action, ActionType } from "./actionTypes";
import { PricelistState } from './state'
import { SaveState } from "app/shared/ui/GenericSaveAndBackButton";
import { readSelectedCentreCode } from "../domain/storage/localStorage";

const startingState: PricelistState = {
    schools: [],
    centres: [],
    countries: [],
    products: [],
    pricingYears: [],
    selectedProductType: 'Accommodation',
    formState: SaveState.NoChanges,
    isLoading: false,
    formErrors: [],
    errorMessage: '',
}

export function reducer(state: PricelistState|undefined, action: Action) : PricelistState {
    if(!state)
        return startingState;

    switch(action.type){
        case ActionType.PageLaded:
            return {
                ...state,
                schools: action.schools,
                centres: action.centres,
                countries: action.countries,
                products: action.products,
                pricingYears: action.pricingYears,
                selectedProductType: action.selectedProductType,
                selectedCentreCode:
                    state.selectedCentreCode || readSelectedCentreCode(),
                selectedPricingYearId: state.selectedPricingYearId,
                formState: action.formState,
                isLoading: action.isLoading,
                formErrors: action.formErrors,
                errorMessage: action.errorMessage,
                pricelist: undefined,
                draftPricelist: undefined,
            };
        case ActionType.ChangeSelectedCentre:
            return {
                ...state,
                selectedCentreCode: action.selectedCentreCode,
                pricelist: [],
                draftPricelist: [],
                errorMessage: ''
            };
        case ActionType.ChangeSelectedProductType:
            return { ...state, selectedProductType: action.selectedProductType};
        case ActionType.ChangeSelectedPricingYear:
            return { ...state, selectedPricingYearId: action.selectedPricingYearId};
        case ActionType.LoadPricelist:
            return { ...state, pricelist: JSON.parse(JSON.stringify(action.pricelist)), draftPricelist: JSON.parse(JSON.stringify(action.pricelist)) };
        case ActionType.LoadDraftPricelist:
            return { ...state, draftPricelist: action.draftPricelist };
        case ActionType.UpdateDraftPricelistItem:
            if (state.draftPricelist) {
                const draftPricelist = state.draftPricelist.slice();
                draftPricelist[action.pricelistIndex] = action.pricelistItem;
                return { ...state, draftPricelist };
            }
            return { ...state };
        case ActionType.SetFormState:
            return { ...state, formState: action.formState, errorMessage: action.errorMessage};
        case ActionType.SetIsLoading:
            return { ...state, isLoading: action.isLoading};
        case ActionType.SetFormErrors:
            return { ...state, formErrors: action.formErrors};
        default:
            return state;
    }
}

export const reducers = {
    reducer
};